<template>
    <div class="basket-product-card" :class="{ disabled: (item.only_pickup && is_delivery)}">
        <div class="basket-product-card-image" :style="{ backgroundImage: `url(${item.image})` }"></div>
        <div class="basket-product-card-header">
            <div class="basket-product-card-title">{{ item.title }}</div>
            <div class="basket-product-card-description">
                <span v-if="item.size" class="size">{{item.size}}{{phrases.PRODUCT_PIZZA_DIAMETR_UNIT}} </span>
                <span v-if="item.dough" class="dough">{{ doughType }} </span>
                <span class="cart-product-card-quantity">x {{ quantity }} {{phrases.PCS}}</span>
            </div>
        </div>
        <div class="basket-product-card-footer">
            <div class="basket-product-card-buttons">
                <div v-if="!isFree" @click="changeQuantity(-1)" class="button-quantity minus">
                  <span class="pp-icon pp-icon-minus"></span>
                </div>
                <div v-if="!isFree && (item.max_quantity_for_an_order == null || item.max_quantity_for_an_order > quantity)"
                     @click="changeQuantity(1)" class="button-quantity plus">
                  <span class="pp-icon pp-icon-plus"></span>
                </div>
            </div>
            <div class="basket-product-card-price" v-if="isFree">{{ phrases.TEXT_FREE }}</div>
          <div class="basket-product-card-price" v-else>{{ sum }}&#8381;</div>
        </div>
        <div class="only-pickup">{{phrases.TEXT_ONLY_PICKUP}}</div>
        <div class="blocked" v-if="(!item.available)">Недоступно</div>
        <div class="blocked text-top-center" v-if="(isNotAvailable)">Доступно по акции "Завтрак" с 09:00-10:00</div>
    </div>
</template>

<script>
    import Utils from "../Utils";
    import {mapGetters} from "vuex";
    import ComboUtils from "@/components/combos/ComboUtils.vue";
    import BasketItemUtils from "@/components/basket/BasketItemUtils.vue";

    export default {
        name: "BasketItem",
        props: {
            item: {},
            quantity: Number,
            index: Number,
            is_delivery: Boolean,
            product: {},
        },
        computed: {
            doughType: function () {
                return this.doughTitle(this.item.dough).toLowerCase();
            },
            isFree: function (){
              return (this.item.isFree !== undefined && this.item.isFree === true);
            },
            sum: function (){
              return this.quantity * this.item.price;
            },
            isNotAvailable: function (){
              // const date = new Date();
              // if(this.item.primary_id !== undefined && this.item.group_id, this.item.primary_id) {
              //   const time_limit = this.$store.getters["catalog/getProduct"](this.item.primary_id, this.item.group_id).time_limit;
              //   return time_limit !== null;
              // }
              return false;
            },
            ...mapGetters('app', {
                phrases: 'getPhrases',
            })
        },
        mixins: [Utils, ComboUtils, BasketItemUtils]
    }
</script>

<style scoped>

</style>
